import { jsPDF } from 'jspdf';

type PlayerLike = {
  firstName?: string;
  lastName?: string;
  playerIdCode?: string;
  ageCategory?: string;
  academyName?: string;
  country?: string;
};

function fullName(p: any): string {
  const fn = p?.firstName || p?.user?.firstName || '';
  const ln = p?.lastName || p?.user?.lastName || '';
  return `${fn} ${ln}`.trim() || 'Player';
}

function playerIdCode(p: any): string {
  return p?.playerIdCode || p?.player_id_code || 'N/A';
}

function drawFrame(doc: jsPDF) {
  const w = doc.internal.pageSize.getWidth();
  const h = doc.internal.pageSize.getHeight();
  doc.setDrawColor(25, 118, 210);
  doc.setLineWidth(1.2);
  doc.rect(10, 10, w - 20, h - 20);
  doc.setLineWidth(0.4);
  doc.rect(14, 14, w - 28, h - 28);
}

export async function generateTrainingCertificatePDF(args: {
  player: PlayerLike | any;
  sport: string;
  periodLabel: string;
  assessmentLabel: string;
  averageRating: number;
  evaluatedBy: string;
  certificateNo: string;
  issuedOn?: string;
}) {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  const w = doc.internal.pageSize.getWidth();

  drawFrame(doc);

  doc.setTextColor(25, 118, 210);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(28);
  doc.text('Certificate of Training Assessment', w / 2, 90, { align: 'center' });

  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(14);
  doc.text('This is to certify that', w / 2, 140, { align: 'center' });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(22);
  doc.text(fullName(args.player), w / 2, 175, { align: 'center' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(12);
  doc.text(`Player ID: ${playerIdCode(args.player)}`, w / 2, 200, { align: 'center' });

  doc.setFontSize(14);
  doc.text(
    `has completed the ${args.assessmentLabel} for ${args.sport} during ${args.periodLabel}.`,
    w / 2,
    245,
    { align: 'center' }
  );

  doc.setFontSize(13);
  doc.text(`Performance (Average Rating): ${Number(args.averageRating || 0).toFixed(2)} / 5`, w / 2, 280, { align: 'center' });
  doc.text(`Evaluated By: ${args.evaluatedBy || 'N/A'}`, w / 2, 305, { align: 'center' });

  doc.setFontSize(11);
  doc.setTextColor(80, 80, 80);
  doc.text(`Issued By: EncycGames`, 40, 360);
  doc.text(`Issued On: ${args.issuedOn || new Date().toLocaleDateString()}`, 40, 380);
  doc.text(`Certificate No: ${args.certificateNo}`, 40, 400);

  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'italic');
  doc.setFontSize(11);
  doc.text('This certificate is generated based on submitted evaluation data.', w / 2, 430, { align: 'center' });

  doc.save(`training-certificate-${args.certificateNo}.pdf`);
}

export async function generateRankingCertificatePDF(args: {
  player: PlayerLike | any;
  sport: string;
  periodLabel: string;
  categoryLabel: string;
  score: number;
  maxScore: number;
  percentage: string;
  grade: string;
  skillsAssessed: number;
  certificateNo: string;
  issuedOn?: string;
}) {
  const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: 'a4' });
  const w = doc.internal.pageSize.getWidth();

  drawFrame(doc);

  doc.setTextColor(25, 118, 210);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(28);
  doc.text('Certificate of Ranking Evaluation', w / 2, 90, { align: 'center' });

  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(14);
  doc.text('This is to certify that', w / 2, 140, { align: 'center' });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(22);
  doc.text(fullName(args.player), w / 2, 175, { align: 'center' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(12);
  doc.text(`Player ID: ${playerIdCode(args.player)}`, w / 2, 200, { align: 'center' });

  doc.setFontSize(14);
  doc.text(`${args.categoryLabel} (${args.sport}) – ${args.periodLabel}`, w / 2, 245, { align: 'center' });

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.text(`Grade: ${args.grade || 'C'}`, w / 2, 280, { align: 'center' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(13);
  doc.text(`Score: ${args.score || 0} / ${args.maxScore || 0} (${args.percentage || '0.0'}%)`, w / 2, 305, { align: 'center' });
  doc.text(`Skills Assessed: ${args.skillsAssessed || 0}`, w / 2, 330, { align: 'center' });

  doc.setFontSize(11);
  doc.setTextColor(80, 80, 80);
  doc.text(`Issued By: EncycGames`, 40, 360);
  doc.text(`Issued On: ${args.issuedOn || new Date().toLocaleDateString()}`, 40, 380);
  doc.text(`Certificate No: ${args.certificateNo}`, 40, 400);

  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'italic');
  doc.setFontSize(11);
  doc.text('This certificate is generated based on submitted evaluation data.', w / 2, 430, { align: 'center' });

  doc.save(`ranking-certificate-${args.certificateNo}.pdf`);
}








